import React, { useState } from "react";
import axios from "axios";
import RoundedButton from "../components/Common/RoundedButton";
import {
  Box,
  TextField,
  Typography,
  Paper,
  Divider,
  Stack,
  InputAdornment,
  Link,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      setError("Enter a valid email");
      return;
    }
    setError("");
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`,
        { email },
        { headers: { "Content-Type": "application/json" } }
      );
      setSubmitted(true);
      toast.success("Reset password link sent successfully");
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
        toast.error(err.response.data.message);
      } else {
        setError("Network error. Please try again.");
        toast.error("Network error. Please try again.");
      }
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        background: `url('/login-background.png') no-repeat center center fixed`,
        backgroundSize: "cover",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          borderRadius: 2,
          px: { xs: 2, sm: 4 },
          py: { xs: 2.5, sm: 4 },
          maxWidth: 420,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box mb={1} display="flex" alignItems="center" justifyContent="center">
          <img
            src="/austin-logo.png"
            alt="Austin Logo"
            style={{
              width: 200,
              objectFit: "contain",
            }}
          />
          <Typography
            variant="h4"
            component="span"
            fontWeight={700}
            color="#555"
            sx={{ letterSpacing: 1 }}
          >
            QC
          </Typography>
        </Box>
        <Divider sx={{ width: "100%", mb: 1 }} />
        <Typography variant="subtitle1" fontWeight={600} align="center">
          Paperless Quality Control System
        </Typography>
        <Typography variant="body2" fontWeight={500} />
        <Divider sx={{ width: "100%", mt: 1, mb: 2 }} />
        {submitted ? (
          <Typography color="success.main" align="center" sx={{ mb: 2 }}>
            If this email is registered, a reset link will be sent.
          </Typography>
        ) : (
          <>
            <Typography align="left" sx={{ mb: 2 }}>
              Enter your registered email address to receive a reset password
              link.
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ width: "100%" }}
            >
              <Stack spacing={2}>
                <TextField
                  label="Email Address"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!error}
                  helperText={error}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                  autoComplete="email"
                />
                <RoundedButton
                  type="submit"
                  variant="contained"
                  sx={{
                    background: "#a20023",
                    borderRadius: 999,
                    fontWeight: "bold",
                    fontSize: "1.05rem",
                    py: 1.2,
                    mt: 1,
                    "&:hover": { background: "#7a001a" },
                  }}
                  fullWidth
                >
                  CONTINUE
                </RoundedButton>
              </Stack>
            </Box>
          </>
        )}
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ width: "100%", mt: 2 }}
        >
          <Link
            component="button"
            variant="body2"
            underline="hover"
            sx={{ color: "#888" }}
            onClick={() => navigate("/login")}
          >
            Back to Login
          </Link>
          <Link
            component="button"
            variant="body2"
            underline="hover"
            sx={{ color: "#888" }}
            onClick={() => alert("Terms and Conditions")}
          >
            Terms and Conditions
          </Link>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
